export default "__VITE_ASSET__D89QeE7Z__"